/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuthenticator } from "@aws-amplify/ui-react";
import LogoHeader from "../components/Authentication/LogoHeader";
import LegalFooterLogin from "../components/Authentication/LegalFooterLogin";
import LegalFooterSignUp from "../components/Authentication/LegalFooterSignUp";
import { signUp, SignUpInput } from "aws-amplify/auth";

export const componentsAuth = {
  Header() {
    return <LogoHeader />;
  },
  SignIn: {
    Footer() {
      const { toForgotPassword } = useAuthenticator();
      return (
        <>
          <div className="text-center align-items-center my-3">
            <a className="btn btn-link" onClick={toForgotPassword}>
              Forgot password?
            </a>
          </div>
          <LegalFooterLogin />
        </>
      );
    }
  },
  SignUp: {
    Footer() {
      return <LegalFooterSignUp />;
    }
  }
};
const urlPattern =
  /^(https?:\/\/)?((localhost)|([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})(:[0-9]{1,5})?(\/[^\s]*)?$/;

export const isValidUrl = (url: string) => urlPattern.test(url);
export const servicesAuth = {
  async handleSignUp(input: SignUpInput) {
    const { username, password } = input;

    const payloadSignUp = {
      username: username,
      password,
      options: {
        ...input.options,
        userAttributes: {
          ...input.options?.userAttributes
        }
      }
    };
    try {
      return await signUp(payloadSignUp);
    } catch (err: any) {
      const errMessage = err.message;
      let customMsgError = errMessage;
      if (customMsgError?.toLowerCase().includes("referral code")) {
        const msgErrorReferral = errMessage
          .split("\n")
          .find((e: string) => e?.toLowerCase().includes("referral code"));
        if (msgErrorReferral) {
          customMsgError = msgErrorReferral;
        }
      }
      throw new Error(customMsgError);
    }
  }
};
export const formFieldsAuth = {
  signIn: {
    username: {
      placeholder: "Enter your Email",
      isRequired: true,
      label: "Email"
    }
  },
  forgotPassword: {
    username: {
      placeholder: "Enter your Email",
      label: "Enter your Email"
    }
  },
  signUp: {
    formFields: {
      name: "custom:referral_code",
      label: "Referral Code (Optional)",
      type: "default",
      placeholder: "Enter your Code"
    }
  }
};
